import Swiper from "swiper";

export default class Aanbod {

    constructor() {
        if (document.querySelector('.aanbod') !== null) {
            this.initIconSlider();
        }
    }

    initIconSlider() {
        new Swiper('#iconSlider .swiper-container', {
            slidesPerView: 1,
            autoplay: {
                delay: 3000,
            },
            speed: 2000,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                }
            }
        });
    }
}
